let currentImgId = '';
let galleryImages = null;

$(document).ready(function() {
  galleryImages = document.getElementsByClassName('gallery-image');
  for (let i = 0; i < galleryImages.length; i++) {
    $('#gallery-image-overlay_' + galleryImages[i].id.split('_')[1]).click(showOverlay(galleryImages[i].id));
  }
  
  $('#gallery-slider-close-button').click(function() {
    document.getElementById('full-screen-gallery-view').style.display = 'none';
  });
  
  $('.gallery-slider-next').click(function() {
    if (currentImgId != 'gallery-image_' + galleryImages.length) {
      setGallerySliderCurrentImage(nextImage(currentImgId));
    }
  });
  
  $('.gallery-slider-prev').click(function() {
    if (currentImgId != 'gallery-image_1') {
	    setGallerySliderCurrentImage(prevImage(currentImgId));
    }
  });
  
  $('#read_review').click(function() {
    $('html, body').animate({
        scrollTop: $("#stamped-main-widget").offset().top
    }, 1500);
  });
  
  $('#write_review').click(function() {
    $('html, body').animate({
        scrollTop: $("#stamped-main-widget").offset().top
    }, 1500);
    $('.stamped-summary-actions-newreview').click();
  });
  
  $('#view-finishes').click(function() {
    $('html, body').animate({
        scrollTop: $("#finishes-section").offset().top
    }, 1500);
  });
});

$(document).keyup(function(e) {
  // escape key should close the overlay if it is open
  if (e.keyCode === 27) {
    if (document.getElementById('full-screen-gallery-view').style.display != 'none' && document.getElementById('full-screen-gallery-view').style.display != '') {
      document.getElementById('full-screen-gallery-view').style.display = 'none';
    }
  }
  
  // right arrow should go to the next image
  if (e.keyCode === 39) {
    if (document.getElementById('full-screen-gallery-view').style.display != 'none' || document.getElementById('full-screen-gallery-view').style.display != '') {
      if (currentImgId != 'gallery-image_' + galleryImages.length) {
        setGallerySliderCurrentImage(nextImage(currentImgId));
      }
    }
  }
  
  // left arrow should go to the previous image
  if (e.keyCode === 37) {
    if (document.getElementById('full-screen-gallery-view').style.display != 'none' || document.getElementById('full-screen-gallery-view').style.display != '') {
      if (currentImgId != 'gallery-image_1') {
        setGallerySliderCurrentImage(prevImage(currentImgId));
      }
    }
  }
});

function showOverlay(i) {
  return function() {
    setGallerySliderCurrentImage(i);
    document.getElementById('full-screen-gallery-view').style.display = 'flex';
  };
}

function setGallerySliderCurrentImage(i) {
  document.getElementById('current-gallery-image').src = document.getElementById(i).src;
  
  if (document.getElementById(i).dataset.caption) {
    $('#gallery-slider-image-caption h2').text(document.getElementById(i).dataset.caption);
  } else {
    $('#gallery-slider-image-caption h2').text('');
  }
  
  currentImgId = i;
}

/*

Input: "gallery-img_10"
Output: "gallery-img_11"

*/
function nextImage(i) {
  let splitId = i.split('_');
  let nextNum = Number(splitId[1]) + 1;
  return `${splitId[0]}_${nextNum}`;
}

/*

Input: "gallery-img_10"
Output: "gallery-img_9"

*/

function prevImage(i) {
  let splitId = i.split('_');
  let nextNum = Number(splitId[1]) - 1;
  return `${splitId[0]}_${nextNum}`;
}
















